import React from 'react';
import GenericPropertiesControl from './GenericPropertiesControl';
import { useBPlanPropertiesStore } from '../../../store/useGeometryPropertiesStore';
import { useGeometryTypeStore } from '../../../store/useGeometryPropertiesStore';

const BPlanPropertiesControl = () => {
  const store = useBPlanPropertiesStore();
  
  // Parse JSON value from store
  const parseJsonValue = (value) => {
    if (!value) return null;
    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch {
        return null;
      }
    }
    return value;
  };

  // Generate dropdown options from array string (for nutzungsart and label)
  const generateOptionsFromArray = (arrayValue) => {
    if (!arrayValue) return [];
    
    try {
      // If it's an array, get the first element
      if (Array.isArray(arrayValue)) {
        if (arrayValue.length === 0) return [];
        
        // Get the first element which contains the actual string
        let cleanedString = String(arrayValue[0]);
        
        // Remove brackets
        cleanedString = cleanedString.replace(/^\[/, '').replace(/\]$/, '');
        
        // Split by quotes and spaces to extract individual items
        const items = cleanedString.match(/'[^']+'/g) || [];
        
        // Clean up each item
        const cleanedItems = items.map(item => 
          item.replace(/'/g, '').trim()
        ).filter(item => item !== '');
        
        return cleanedItems.map(item => ({
          label: item,
          value: item
        }));
      }
      
      // Convert to string if it's an object or other type
      let cleanedString = String(arrayValue);
      
      // Remove "0: [" or similar patterns
      cleanedString = cleanedString.replace(/^\d+:\s*\[/, '');
      // Remove trailing ]
      cleanedString = cleanedString.replace(/\]$/, '');
      
      // Split by quotes and spaces to extract individual items
      const items = cleanedString.match(/'[^']+'/g) || [];
      
      // Clean up each item
      const cleanedItems = items.map(item => 
        item.replace(/'/g, '').trim()
      ).filter(item => item !== '');
      
      return cleanedItems.map(item => ({
        label: item,
        value: item
      }));
    } catch (error) {
      console.error('Error parsing array value:', error);
      return [];
    }
  };

  const nutzungsartOptions = generateOptionsFromArray(store.nutzungsart);
  const labelOptions = generateOptionsFromArray(store.label);

  const properties = [
    { key: 'objectID', label: 'Objekt-ID', value: store.objectId },
    { key: 'type', label: 'Typ', value: store.objectType },
    { 
      key: 'url', 
      label: 'URL', 
      value: store.url || 'Kein Link verfügbar'
    },
    { 
      key: 'label', 
      label: 'Label', 
      value: Array.isArray(store.label) && store.label.length > 0 ? store.label[0] : store.label,
      options: labelOptions.map(opt => opt.value)
    },
    { key: 'kommune', label: 'Kommune', value: store.kommune },
    { 
      key: 'nutzungsart', 
      label: 'Nutzungsart', 
      value: Array.isArray(store.nutzungsart) && store.nutzungsart.length > 0 ? store.nutzungsart[0] : store.nutzungsart,
      options: nutzungsartOptions.map(opt => opt.value)
    },
    { key: 'status', label: 'Letzte Aktualisierung', value: store.status },
  ];

  const handlePropertyUpdate = (key, value) => {
    store.updateProperty(key, value);
  };

  return (
    <GenericPropertiesControl 
      properties={properties}
      onPropertyUpdate={handlePropertyUpdate}
      title="EIGENSCHAFTEN"
    />
  );
};

export default BPlanPropertiesControl;